import { render, staticRenderFns } from "./MerchantAssetsView.vue?vue&type=template&id=7384364e&"
import script from "./MerchantAssetsView.vue?vue&type=script&lang=js&"
export * from "./MerchantAssetsView.vue?vue&type=script&lang=js&"
import style0 from "./MerchantAssetsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports